// extracted by mini-css-extract-plugin
export default {"crumb":"breadcrumbs_crumb__EhWbV","crumb__active":"breadcrumbs_crumb__active__WcSrL","crumb__separator":"breadcrumbs_crumb__separator__IPWUj","crumbs":"breadcrumbs_crumbs__R6lNt"};